<template>
  <div>
    <q-btn
      v-if="isSuperAdmin"
      flat
      round
      dense
      icon="mdi-cog"
      color="red"
    >
      <q-tooltip>Admin Configuration</q-tooltip>
      <q-menu anchor="bottom right" self="top right">
        <q-card style="min-width: 350px">
          <q-card-section class="bg-primary text-white">
            <div class="text-h6">
              <q-icon name="mdi-cog" class="q-mr-sm"></q-icon>
              Admin Configuration
            </div>
            <div class="text-caption">SuperAdmin Settings</div>
          </q-card-section>

          <q-separator />

          <q-card-section>
            <div class="text-subtitle2 text-accent q-mb-md">
              Overlay Settings
            </div>
            
            <q-item tag="label" class="q-px-none">
              <q-item-section>
                <q-item-label>SuperAdmin Bypass Overlays Enabled</q-item-label>
                <q-item-label caption class="text-grey-7">
                  When enabled, SuperAdmins can see overlays on all devices regardless of the device's overlaysEnabled setting
                </q-item-label>
              </q-item-section>
              <q-item-section side>
                <q-toggle
                  :value="superAdminBypassOverlaysEnabled"
                  @input="toggleSuperAdminBypass"
                  color="primary"
                />
              </q-item-section>
            </q-item>

            <q-separator class="q-my-md" />

            <div class="text-caption text-grey-6 q-mb-sm">
              Current Status: 
              <span :class="superAdminBypassOverlaysEnabled ? 'text-positive' : 'text-negative'">
                {{ superAdminBypassOverlaysEnabled ? 'Bypass Enabled' : 'Bypass Disabled' }}
              </span>
            </div>
            
            <div class="text-caption text-grey-6">
              <q-icon name="mdi-information" size="xs" class="q-mr-xs"></q-icon>
              When bypass is disabled, SuperAdmins will only see overlays on devices with overlaysEnabled = 1
            </div>
          </q-card-section>

          <q-separator />

          <q-card-section class="q-pt-sm">
            <q-btn
              flat
              dense
              color="grey-7"
              label="Reset to Defaults"
              icon="mdi-restore"
              size="sm"
              @click="resetConfig"
              class="full-width"
            />
          </q-card-section>
        </q-card>
      </q-menu>
    </q-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ConfigMenu",
  computed: {
    ...mapGetters({
      currentUserData: "auth/currentUserData",
      superAdminBypassOverlaysEnabled: "adminConfig/superAdminBypassOverlaysEnabled"
    }),
    isSuperAdmin() {
      return this.currentUserData && this.currentUserData.role === "superAdmin";
    }
  },
  methods: {
    ...mapActions({
      toggleSuperAdminBypassOverlaysEnabledAction: "adminConfig/toggleSuperAdminBypassOverlaysEnabled",
      resetToDefaults: "adminConfig/resetToDefaults"
    }),
    toggleSuperAdminBypass() {
      this.toggleSuperAdminBypassOverlaysEnabledAction();
      this.$q.notify({
        message: `SuperAdmin Overlay Bypass ${this.superAdminBypassOverlaysEnabled ? 'Disabled' : 'Enabled'}`,
        color: 'primary',
        icon: 'mdi-cog',
        position: 'top',
        timeout: 2000
      });
    },
    resetConfig() {
      this.$q.dialog({
        title: 'Reset Configuration',
        message: 'Are you sure you want to reset all configuration settings to defaults?',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.resetToDefaults();
        this.$q.notify({
          message: 'Configuration reset to defaults',
          color: 'positive',
          icon: 'mdi-check',
          position: 'top',
          timeout: 2000
        });
      });
    }
  }
};
</script>

<style scoped>
.q-item {
  padding-left: 0;
  padding-right: 0;
}
</style>
